import { render, staticRenderFns } from "./BasePaginationTab.vue?vue&type=template&id=b29148e4"
import script from "./BasePaginationTab.vue?vue&type=script&lang=js"
export * from "./BasePaginationTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports